enum QueryKeys {
	ROLES = 'roles',
	USERS = 'users',
	BUSINESS_UNIT = 'business-unit',
	BILLING_ADDRESSES = 'billing-addresses',
	EQUIPMENT_DOCUMENTS_QUESTION = 'my-equipment-documents-question',
	ADDRESSES = 'addresses',
	ASSOCIATES = 'associates',
	CART = 'cart',
	DICTIONARY = 'dictionary',
	CHECK_APPROVAL = 'check-approval',
	BUSINESS_UNITS = 'business-units',
	CONTACTS = 'contacts',
	CUSTOM_TRAINING = 'custom-training',
	EQUIPMENT = 'equipment',
	DOCUMENT = 'document',
	DOCUEMENT_DOWNLOAD = 'document-download',
	ORDERS = 'orders',
	ORDER = 'order',
	COUNTRIES = 'countries',
	SPARE_PARTS = 'spare-parts',
	PRODUCT = 'product',
	QUOTES = 'quotes',
	QUOTE = 'quote',
	QUOTE_DOWNLOAD = 'quote-download',
	SPAREPARTS_SEARCH_CATALOG = 'spareparts-search-catalog',
	SPAREPARTS_SEARCH_QUICK_ORDER = 'spareparts-search-quick-order',
	SPARE_PART = 'spare-part',
	QUICK_ORDER = 'quick-order',
	FAQ = 'locale',
}

export default QueryKeys;
